export const environment = {
  baseUrl: 'https://zitecmanagerbackend-dev.zitec.ai',
  notificationsHubUrl: 'https://zitecmanagerbackend-dev.zitec.ai/hubs/notifications',
  title: 'Develop - Zitec',
  ambiente: 'developer',
  // Nunca true fora de environment.local.ts — desativaria a proteção do reCAPTCHA
  // na verificação de telefone por SMS.
  disableRecaptchaForE2E: false,
  // Config do projeto Firebase (WEB, pública) — usada pelo RecaptchaVerifier na
  // verificação de telefone por SMS. NÃO colocar aqui a service account (chave privada).
  firebase: {
    apiKey: 'AIzaSyCOp24z9MRUaQssOTMYLp8nWYbfgyMMPog',
    authDomain: 'zitecweb.firebaseapp.com',
    projectId: 'zitecweb',
    storageBucket: 'zitecweb.firebasestorage.app',
    messagingSenderId: '711604644706',
    appId: '1:711604644706:web:972fd81557e8b15f17da3b',
  },
};
